import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aba-lasanha-cadastro-produtos',
  templateUrl: './aba-lasanha-cadastro-produtos.component.html',
  styleUrls: ['./aba-lasanha-cadastro-produtos.component.css'],
})
export class AbaLasanhaCadastroProdutosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
